import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

import Home from './views/Home.vue'
import Courses from './views/Courses.vue'
import Login from './views/Login.vue'
import Customers from './views/Customers.vue'
import Book from './views/Book.vue'
import Instructors from './views/Instructors.vue'
import Settings from './views/Settings.vue'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/courses',
      name: 'courses',
      component: Courses
    },
    {
      path: '/customers',
      name: 'customers',
      component: Customers
    },
    {
      path: '/instructors',
      name: 'instructors',
      component: Instructors
    },
    {
      path: '/book',
      name: 'book',
      component: Book
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    }
  ]
})

router.beforeEach((to, from, next) => {
  
  if (to.fullPath !== '/login' && to.path !== '/book') {
    if (!store.state.token) {
      next('/book');
    }
  }

  if (to.fullPath === '/login') {
    if (store.state.token) {
      next('/');
    }
  }

  next();
});

export default router
